import React from 'react'

export type DrawerHeaderProps = {
    left?: React.ReactNode
    middle?: React.ReactNode
    right?: React.ReactNode
    className?: string
}

const DrawerHeader = ({ left, middle, right, className }: DrawerHeaderProps) => {
    return (
        <div className={`flex w-full flex-wrap items-center gap-3 ${className}`}>
            <div className="min-w-0">{left}</div>
            {middle ? <div className="min-w-0 flex-1">{middle}</div> : <div className="flex-1" />}
            <div className="ml-auto flex items-center gap-2">{right}</div>
        </div>
    )
}

export default DrawerHeader
